import AuthService from "../login/auth.service";
import { consultasAPI } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class SucursalesService {
  async obtenerSucursales() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: consultasAPI + "sucursales/obtenerSucursales",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

 
}
export default new SucursalesService();
